require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-11-29-joost-on-the-iphone.json") })
        }
      }, "path---articles-2008-11-29-joost-on-the-iphone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-11-29-joost-on-the-iphone!./.cache/json/articles-2008-11-29-joost-on-the-iphone.json
// module id = 557
// module chunks = 231608221292675